/* eslint-disable max-len */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
import React, { useContext } from 'react';
import { QueryProvider, QueryContext } from '@thd-nucleus/data-sources';

const ssr = typeof window === 'undefined';

let EmtGeneratedContentImport;
let SeoGeneratedContentImport;
let SeoLinksImport;

/** *********************
 * Emt Generated Content
 ********************** */
export const EmtGeneratedContentLoad = () => import(
  /* webpackChunkName: "emt-generated-content" */
  '@thd-olt-component-react/seo-generated-content/dist/components/EmtGeneratedContent')
  .then((module) => {
    const { EmtGeneratedContent } = module;

    EmtGeneratedContentImport = (props) => {
      const value = useContext(QueryContext);
      return (
        <QueryProvider cacheKey="emt-generated-content" defaultVariables={value.defaultVariables.current}>
          <EmtGeneratedContent {...props} />
        </QueryProvider>
      );
    };
  });

export const EmtGeneratedContent = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/seo-generated-content/dist/components/EmtGeneratedContent')).EmtGeneratedContent
  : (props) => <EmtGeneratedContentImport {...props} />;

export const EmtGeneratedContentModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/seo-generated-content/dist/components/EmtGeneratedContent')).EmtGeneratedContent.dataModel
  : {};

/** *********************
 * Seo Generated Content
 ********************** */
export const SeoGeneratedContentLoad = () => import(
  /* webpackChunkName: "emt-generated-content" */
  '@thd-olt-component-react/seo-generated-content')
  .then((module) => {
    const { SeoGeneratedContent } = module;

    SeoGeneratedContentImport = (props) => {
      const value = useContext(QueryContext);
      return (
        <QueryProvider cacheKey="seo-generated-content" defaultVariables={value.defaultVariables.current}>
          <SeoGeneratedContent {...props} />
        </QueryProvider>
      );
    };
  });

export const SeoGeneratedContent = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/seo-generated-content')).SeoGeneratedContent
  : (props) => <SeoGeneratedContentImport {...props} />;

export const SeoGeneratedContentModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/seo-generated-content')).SeoGeneratedContent.dataModel
  : {};

/** *********************
 * Seo Links
 ********************** */
export const SeoLinksLoad = () => import(
  /* webpackChunkName: "emt-links" */
  '@thd-olt-component-react/seo-links')
  .then((module) => {
    const { SeoLinks } = module;

    SeoLinksImport = (props) => {
      const value = useContext(QueryContext);
      return (
        <QueryProvider cacheKey="seo-links" defaultVariables={value.defaultVariables.current}>
          <SeoLinks {...props} />
        </QueryProvider>
      );
    };
  });

export const SeoLinks = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/seo-links')).SeoLinks
  : (props) => <SeoLinksImport {...props} />;

export const SeoLinksModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/seo-links')).SeoLinks.dataModel
  : {};
